module.exports = __webpack_public_path__ + "static/media/Choir2.e6e283f1.jpg";